var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content contentBac" },
    [
      _c(
        "el-form",
        {
          ref: "addForm",
          attrs: {
            model: _vm.addData,
            rules: _vm.rules,
            "label-width": "130px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "上传标号：", prop: "programId" } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { type: "text" },
                model: {
                  value: _vm.addData.upMonitorNum,
                  callback: function($$v) {
                    _vm.$set(_vm.addData, "upMonitorNum", $$v)
                  },
                  expression: "addData.upMonitorNum"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "读取方式", prop: "name" } },
            [
              _c(
                "el-radio",
                {
                  attrs: { label: "0" },
                  on: { change: _vm.handleChangeSubjoin },
                  model: {
                    value: _vm.addData.upReadType,
                    callback: function($$v) {
                      _vm.$set(_vm.addData, "upReadType", $$v)
                    },
                    expression: "addData.upReadType"
                  }
                },
                [_vm._v("全部")]
              ),
              _vm._v(" "),
              _c(
                "el-radio",
                {
                  attrs: { label: "1" },
                  on: { change: _vm.handleChangeSubjoin },
                  model: {
                    value: _vm.addData.upReadType,
                    callback: function($$v) {
                      _vm.$set(_vm.addData, "upReadType", $$v)
                    },
                    expression: "addData.upReadType"
                  }
                },
                [_vm._v("自定义")]
              ),
              _vm._v(" "),
              _vm.addData.upReadType === "1"
                ? _c(
                    "div",
                    [
                      _c("DetailReportTable", {
                        ref: "reportTable",
                        attrs: { reportTable: _vm.addData.upReadSettings }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "数据解析方法：", prop: "languageId" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.addData.upDataParser,
                    callback: function($$v) {
                      _vm.$set(_vm.addData, "upDataParser", $$v)
                    },
                    expression: "addData.upDataParser"
                  }
                },
                _vm._l(_vm.dataAnalysisList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.name, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "是否转换", prop: "name" } },
            [
              _c(
                "el-radio",
                {
                  attrs: { label: "true" },
                  on: { change: _vm.handleChangeFunctionShow },
                  model: {
                    value: _vm.addData.isUpModelConvert,
                    callback: function($$v) {
                      _vm.$set(_vm.addData, "isUpModelConvert", $$v)
                    },
                    expression: "addData.isUpModelConvert"
                  }
                },
                [_vm._v("需要")]
              ),
              _vm._v(" "),
              _c(
                "el-radio",
                {
                  attrs: { label: "false" },
                  on: { change: _vm.handleChangeFunctionShow },
                  model: {
                    value: _vm.addData.isUpModelConvert,
                    callback: function($$v) {
                      _vm.$set(_vm.addData, "isUpModelConvert", $$v)
                    },
                    expression: "addData.isUpModelConvert"
                  }
                },
                [_vm._v("不需要")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }